import { createRouter, createWebHistory } from 'vue-router';
import Home from './views/Home.vue'; // Assuming you have a Home.vue file in the views folder
import Cheatsheet from './views/Cheatsheet.vue'; // Assuming you have a Cheatsheet.vue file in the views folder
import VoiceTrainer from './views/VoiceTrainer.vue';
const routes = [
    {
      path: '/',
      name: 'Home',
      component: Home,
    },
    {
      path: '/tenses',
      name: 'Tenses',
      component: Cheatsheet,
    },
    {
      path: '/voice',
      name: 'Voice',
      component: VoiceTrainer,
    },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});


export default router;